module.exports = "/images/ingredients-6.png";